import {useAppForm} from '@/providers/components/formProvider';

type FormGlobalErrorPropsT = {
  formId: string;
  className?: string;
};

function FormGlobalError({formId, className}: FormGlobalErrorPropsT) {
  const {
    state: {globalError, loading},
  } = useAppForm({formId});

  if (!globalError || loading) return null;

  return (
    <div className={className}>
      <div className="alert alert-danger" role="alert">
        {globalError}
      </div>
    </div>
  );
}

export default FormGlobalError;
